/**
 * LiveKit ↔ Agora identity bridge (CORE-393).
 *
 * The whole room/live UI keys remote participants by a numeric Agora `uid`
 * (RemoteUser.uid, Set<number> for speaking/video, `${uid}` container maps).
 * LiveKit identifies participants by a string `identity`. To reuse the existing
 * numeric-keyed rendering unchanged, we derive a stable non-negative 32-bit-ish
 * numeric uid from the identity string (djb2 hash, mod 1e9 to stay in Agora's
 * uint range). It only needs to be stable + collision-rare within one room —
 * it is NOT required to match the backend's C# hash.
 */

const MOD = 1_000_000_000;

/** Deterministic non-negative numeric uid for a LiveKit identity string. */
export function identityToUid(identity: string): number {
  let hash = 5381;
  for (let i = 0; i < identity.length; i++) {
    // hash * 33 + c, kept in the 32-bit range via >>> 0
    hash = ((hash << 5) + hash + identity.charCodeAt(i)) >>> 0;
  }
  const uid = hash % MOD;
  // 0 is reserved for the local participant in the numeric-uid model.
  return uid === 0 ? 1 : uid;
}
